"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverables = exports["default"] = exports.clickables = exports.Price = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _theme = require("../../constants/theme");
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
var _Body = _interopRequireDefault(require("../primitive/Body"));
var _Label = require("../primitive/Label");
var _dateOpts = require("../../constants/dateOpts");
var _customizationClassNames = require("../../constants/customizationClassNames");
var _excluded = ["label", "children", "icon", "date"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var clickables = exports.clickables = ['bookable', 'bookable-soldout', 'bookable-within', 'bookable-outside', 'selected-start', 'selected-end', 'selected'];
var hoverables = exports.hoverables = ['bookable', 'bookable-within', 'bookable-outside', 'bookable-soldout'];
var externalClassVariantMap = {
  selected: _customizationClassNames.CLASS_PLANNER_DAY_SELECTED,
  blocked: _customizationClassNames.CLASS_PLANNER_DAY_BLOCKED,
  'selected-start': _customizationClassNames.CLASS_PLANNER_DAY_SELECTED_START,
  'selected-end': _customizationClassNames.CLASS_PLANNER_DAY_SELECTED_END,
  'bookable-outside': _customizationClassNames.CLASS_PLANNER_DAY_BOOKABLE_OUTSIDE,
  'bookable-within': _customizationClassNames.CLASS_PLANNER_DAY_BOOKABLE_WITHIN,
  within: _customizationClassNames.CLASS_PLANNER_DAY_WITHIN,
  bookable: _customizationClassNames.CLASS_PLANNER_DAY_BOOKABLE
};
var PlannerDay = (0, _react.memo)(function (_ref) {
  var label = _ref.label,
    children = _ref.children,
    icon = _ref.icon,
    date = _ref.date,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledBox, {
    className: _customizationClassNames.CLASS_PLANNER_CONTAINER,
    id: date && (0, _format["default"])(date, 'yyyy-MM-dd', (0, _dateOpts.getDateOpts)('nl'))
  }, /*#__PURE__*/_react["default"].createElement(Container, Object.assign({}, props, {
    type: "button",
    as: props.variant && clickables.includes(props.variant) ? undefined : 'span'
  }), /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: "".concat(_customizationClassNames.CLASS_PLANNER_DAY, " ").concat(props.variant ? externalClassVariantMap[props.variant] : '')
  }, /*#__PURE__*/_react["default"].createElement(_grid.Box, null, date && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_grid.Flex, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Body["default"], {
    style: {
      font: 'inherit'
    }
  }, (0, _format["default"])(date, 'd')), icon), label && /*#__PURE__*/_react["default"].createElement(Price, null, label))))));
}, function (prev, next) {
  if (prev.date && next.date && +prev.date !== +next.date) {
    return false;
  }

  // Only rerender if the day is subjected to change
  var relevantVariants = [].concat(clickables, ['within']);
  if (next.variant && prev.variant === next.variant && prev.isSelecting !== next.isSelecting) {
    return !relevantVariants.includes(next.variant);
  }
  var ignoredKeys = ['date', 'isSelecting', 'onClick', 'onMouseEnter', 'onMouseDown', 'onMouseLeave'];
  return Object.keys(prev).filter(function (key) {
    return !ignoredKeys.includes(key);
  }).every(function (key) {
    return Object.is(prev[key], next[key]);
  });
});
var _default = exports["default"] = PlannerDay;
var Price = exports.Price = (0, _styledComponents["default"])(_Body["default"]).attrs({
  variant: 'small'
}).withConfig({
  displayName: "PlannerDay__Price",
  componentId: "sc-12nbo61-0"
})(["font-weight:600;"]);
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PlannerDay__Wrapper",
  componentId: "sc-12nbo61-1"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;"]);
var defaultCss = (0, _styledComponents.css)(["margin:2px 0;color:", ";", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral['70'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.body.regular);
});
var disabledCss = (0, _styledComponents.css)(["background:repeating-linear-gradient( -45deg,#eaeaea,#eaeaea 2px,rgba(235,235,235,0) 2px,rgba(235,235,235,0) 5px );margin-left:2px;margin-right:2px;color:", ";font-weight:400;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['30'];
});

/**
 * Todo: clean up the conditional statements
 */
var bookableCss = (0, _styledComponents.css)(["color:", " !important;font-weight:600;background:", ";margin-left:2px;margin-right:2px;:focus,:hover{color:", " !important;}"], function (_ref5) {
  var theme = _ref5.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookable.color);
}, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookable.backgroundColor);
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookable.focusColor);
});
var bookableSoldoutCss = (0, _styledComponents.css)(["color:", " !important;font-weight:600;background:#ffffff;margin-left:2px;margin-right:2px;border:2px #eaeaea solid;"], function (_ref8) {
  var theme = _ref8.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookable.color);
});
var selectedCss = (0, _styledComponents.css)(["color:", " !important;font-weight:600;border-radius:var(--borderRadius);background:", " !important;:focus,:hover{--border-color:", " !important;}svg{color:currentColor;}"], function (_ref9) {
  var theme = _ref9.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.selected.color);
}, function (_ref10) {
  var theme = _ref10.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.selected.backgroundColor);
}, function (_ref11) {
  var theme = _ref11.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.selected.focusColor);
});
var selectedStartCss = (0, _styledComponents.css)(["", ";border-radius:var(--borderRadius) 0 0 var(--borderRadius);margin-left:2px;"], selectedCss);
var selectedEndCss = (0, _styledComponents.css)(["", ";border-radius:0 var(--borderRadius) var(--borderRadius) 0;margin-right:2px;"], selectedCss);
var periodCss = (0, _styledComponents.css)(["::after{content:'';background:", " !important;position:absolute;z-index:-1;left:0;top:0;height:100%;width:100%;transition-property:background;transition-duration:0.2s;transition-timing-function:ease-in;}"], function (_ref12) {
  var theme = _ref12.theme,
    isSelecting = _ref12.isSelecting;
  return isSelecting ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.periodBackground.selected) : (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.periodBackground.notSelected);
});
var withinCss = (0, _styledComponents.css)(["", ";color:", " !important;transition-property:color;transition-duration:0.2s;transition-timing-function:ease-in;"], periodCss, function (_ref13) {
  var theme = _ref13.theme,
    isSelecting = _ref13.isSelecting;
  return isSelecting ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.withinCss.selected) : (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.withinCss.notSelected);
});
var bookableWithinCss = (0, _styledComponents.css)(["", ";", "{color:inherit;}color:", " !important;font-weight:600;"], periodCss, Price, function (_ref14) {
  var theme = _ref14.theme,
    isSelecting = _ref14.isSelecting;
  return isSelecting ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookableWithin.selected) : (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookableWithin.notSelected);
});
var bookableOutsideCss = (0, _styledComponents.css)(["", "{color:", " !important};}color:", " !important;font-weight:600;"], Price, function (_ref15) {
  var theme = _ref15.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.price);
}, function (_ref16) {
  var theme = _ref16.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.calendar.bookableOutside);
});
var loadingCss = (0, _styledComponents.css)(["> div{width:60%;height:60%;border-radius:0.8rem;background:", ";}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.neutral['10'];
});
var blockedCss = (0, _styledComponents.css)(["", ";"], disabledCss);
var getCss = function getCss(variant) {
  switch (variant) {
    case 'default':
      return defaultCss;
    case 'disabled':
      return disabledCss;
    case 'bookable':
      return bookableCss;
    case 'selected':
      return selectedCss;
    case 'selected-start':
      return selectedStartCss;
    case 'selected-end':
      return selectedEndCss;
    case 'within':
      return withinCss;
    case 'bookable-within':
      return bookableWithinCss;
    case 'bookable-outside':
      return bookableOutsideCss;
    case 'bookable-soldout':
      return bookableSoldoutCss;
    case 'loading':
      return loadingCss;
    case 'blocked':
      return blockedCss;
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var StyledBox = _styledComponents["default"].div.withConfig({
  displayName: "PlannerDay__StyledBox",
  componentId: "sc-12nbo61-2"
})(["width:calc(100% / 7);position:relative;::after{content:'';padding-top:100%;display:block;width:100%;height:0;}"]);
var Container = _styledComponents["default"].button.withConfig({
  displayName: "PlannerDay__Container",
  componentId: "sc-12nbo61-3"
})(["--borderRadius:4px;font:inherit;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;padding:0;height:100%;outline:none;margin:0;> ", "{height:100%;max-height:100%;--border-color:transparant;border-radius:var(--borderRadius);font-family:", ";background-clip:content-box;box-shadow:inset 0 0 0 2px var(--border-color);", ";}> ", "{margin-top:0;}svg{color:inherit;margin-left:0.4rem;}"], Wrapper, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontFamily.body;
}, function (_ref19) {
  var _ref19$variant = _ref19.variant,
    variant = _ref19$variant === void 0 ? 'default' : _ref19$variant;
  return getCss(variant);
}, _Label.Label);
//# sourceMappingURL=PlannerDay.js.map